import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { PortfolioPerformanceSummaryModel } from '../../../Models/Models/PortfolioAnalysis/Performance/PortfolioPerformanceSummaryModel';
import { IJsonDate } from '../../../System/IJsonDate';
import { PerformanceMethod } from '../../../Constants/Enums/Domain/PerformanceMethod';

declare var IS_RUNNING_IN_APP_POOL;

export class PerformanceSummaryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fromDateTime: IJsonDate, toDateTime: IJsonDate, fromInception: boolean, performanceMethod: PerformanceMethod, subAccountHierarchyIds: Array<string>): Promise<PortfolioPerformanceSummaryModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/PerformanceSummary/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDateTime: fromDateTime, toDateTime: toDateTime, fromInception: fromInception, performanceMethod: performanceMethod, subAccountHierarchyIds: subAccountHierarchyIds }

    return AjaxWrapper.get<PortfolioPerformanceSummaryModel, any>(url, data);
  }
}

